// extracted by mini-css-extract-plugin
export var errorsContainer = "_qf-1";
export var link = "_qf-0";